import { render, staticRenderFns } from "./AllClaimHelpList.vue?vue&type=template&id=04cd23f9&"
import script from "./AllClaimHelpList.vue?vue&type=script&lang=js&"
export * from "./AllClaimHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports